import { Link } from "react-router-dom";
import { useWallet } from "../context/WalletContext.jsx";

/**
 * Drop-in replacement for react-router's Link that requires a connected
 * wallet before navigating. When no wallet is connected, the click is
 * intercepted, the wallet-connect modal opens, and the original `to` is
 * stashed as the pending destination so a successful connect lands the
 * user on the page they originally asked for. If the user rejects or
 * closes the modal, no navigation occurs.
 */
export default function GatedLink({ to, onClick, children, ...rest }) {
    const { address, requestConnect } = useWallet();

    function handleClick(event) {
        if (onClick) onClick(event);
        if (event.defaultPrevented) return;
        if (address) return;
        event.preventDefault();
        requestConnect(typeof to === "string" ? to : null);
    }

    return (
        <Link to={to} onClick={handleClick} {...rest}>
            {children}
        </Link>
    );
}
